import { GRAMMAR_MASTERY_STATES } from '@repo/config';
import { z } from 'zod';

const grammarUserStateSchemaDefinition = z.object({
  pointId: z.number().int(),
  level: z.number().int().min(0),
  nextReviewAt: z.number().int(),
  mastery: z.enum(GRAMMAR_MASTERY_STATES),
  lapses: z.number().int().min(0),
  passed: z.number().int().min(0),
  failed: z.number().int().min(0),
  recentItemIds: z.array(z.number().int()),
  lastReviewedAt: z.number().int(),
});

export const grammarUserStateSchema: typeof grammarUserStateSchemaDefinition =
  grammarUserStateSchemaDefinition;

export type IGrammarUserState = z.infer<typeof grammarUserStateSchema>;
